<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Setting Aplikasi</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Setting aplikasi</span>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 lg:col-10 lg:col-offset-1">
        <div class="card bg-white">
          <grid-setting
            :items="items"
            :loading="isLoading"
            @edit="onEditData"
          />
        </div>
      </div>
    </div>
    <Dialog
      :header="form ? 'Update ' + form.name : ''"
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '25vw' }"
      :modal="true"
    >
      <form-setting :item="form" :loading="isLoadingSave" @save="onSaveData" />
    </Dialog>
  </div>
</template>

<script>
import SettingService from '@/services/SettingService'
import FormSetting from '@/components/master/FormSetting'
import errorHandler from '@/helpers/error-handler'
import GridSetting from '@/components/master/GridSetting'

export default {
  name: 'Setting',
  components: {
    GridSetting,
    FormSetting,
  },
  data() {
    return {
      settingService: null,
      dialog: false,
      isLoading: false,
      isLoadingSave: false,
      items: [],
      //initialValue: [],
      form: {},
    }
  },
  created() {
    this.settingService = new SettingService()
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.isLoading = true
      this.settingService
        .get()
        .then((res) => {
          this.items = res.data.data
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data setting', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onEditData(data) {
      this.form = Object.assign({}, data)
      //this.initialValue = this.form.initial_value
      this.dialog = true
    },
    onSaveData(data) {
      this.isLoadingSave = true
      
      const arrInit = data.initial_value
      const selectVal = data.value
      if (data.type == "combobox") {
        const isFound = arrInit.indexOf(selectVal) > -1
        if (!isFound) data.initial_value.push(selectVal)
      }

      const newData = { key: data.key, value: data }
      const id = data.id
      delete newData.value.key
      delete newData.value.id

      this.settingService
        .update(id, newData)
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Data Setting',
              detail: 'Setting berhasil disimpan.',
              life: 3000,
            })
            this.loadData()
            this.dialog = false
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Setting', this)
        })
        .finally(() => (this.isLoadingSave = false))
    },
  },
}
</script>
